import React, {useEffect, useState, useCallback} from "react";
import {
  useParams,
  useLocation,
  useHistory,
  useRouteMatch,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import CustomCarousel from "../components/Carousel/Carousel";
import PromoProducts from "../containers/PromoProducts/PromoProducts";
import NewProducts from "../containers/NewProducts/NewProducts";
import ShopByCategory from "../containers/ShopByCategory/ShopByCategory";
import ReviewCard from "../containers/ReviewCard/ReviewCard";
import CartPopUp from "../containers/Cart/CartPopUp";
import LazySection from "../components/LazySection/LazySection";
import CarouselSkeleton from "../components/Skeletons/CarouselSkeleton";
import ReviewSkeleton from "../components/Skeletons/ReviewSkeleton";
import PartnerSkeleton from "../components/Skeletons/PartnerSkeleton";
import CategoryListSkeleton from "../components/Skeletons/CategoryListSkeleton";
import HeroSkeleton from "../components/Skeletons/HeroSkeleton";
import {
  MainContentArea,
  ContentSection,
  OfferSection,
} from "../styled/pages.style";

import delishopExpressIcon from '../assets/icons/delixpress_logo2.svg';
import { ExpressStyle } from "../styled/express.style";

import { useDeviceType } from "../helper/useDeviceType";
import {setCookie} from "../helper/constant";
import queryString from "query-string";
import { connect } from "react-redux";
import {
  productCategory,
  ProductModalData,
  searchSuggestions,
  searchStoreProduct,
  getProductsMappedwithSubCat,
  getProductsMappedwithCat,
  getProductOutOfStock,
  getProductOutOfStockCat,
  getPromotionProducts,
  getArrivalProducts,
  getTrendingProducts,
  getProductBrands,
  getProductFilterBrands,
  getSortProductsName,
  getSortProductsPrice,
  sortByNameProduct,
  Reset_Suggestions,
  changePage,
  resetPage
} from "../store/actions/productAction";
import {
  slotsForDate,
  alldeliverySlots,
} from "../store/actions/userAction";
import {
  getPartnerPages,
  oosModified,
} from "../store/actions/globalAction";
import {
  useCart
} from "../contexts/cart/use-cart";
import {
  useFavorites
} from "../contexts/favorites/use-favorites";
import { offerSlider } from "../store/actions/globalAction";
import API from "../network/dashboardAPI"
import redAPI from "../network/redAPI"
import t from '../i18n/translate';
import expressService from "../services/expressService";

import ProductOfTheWeekCart from './../components/ProductOfTheweekCart/ProductOfTheWeekCart';
import TypeCategoriesBanner from "../components/typeCategoriesBanner/TypeCategoriesBanner";
import HomePageVideo from './../components/HomePageVideo/HomePageVideo';
import SalePromotionCampaignBanner from "../components/SalePromotionCampaign/SalePromotionCampaignBanner";
import { checkShowCampaignBanner, getActivePromotionCampaign, minusHour, resetActivePromotionCampaign } from "../store/actions/promotionCampaignAction";
import { CampaignDescriptions } from "../containers/SalePromotionCampaign/SaleCampaign.style";
import SaleCampaignTimer from "../containers/SalePromotionCampaign/CampaignTimer";
import { Spinner } from "react-bootstrap";
import PartnerHome from "../containers/PartnerHome/PartnerHome";

const PAGE_TYPE = "grocery";

const useRouter = () => {
  const params = useParams();

  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  return React.useMemo(() => {
    return {
      push: history.push,
      replace: history.replace,
      pathname: location.pathname,
      query: {
        ...queryString.parse(location.search),
        ...params,
      },
      match,
      location,
      history,
    };
  }, [params, match, location, history]);
};

const HomePage = (props, { userAgent }) => {
  const deviceType = useDeviceType(userAgent);
	const {query} = useRouter();
  const targetRef = React.useRef(null);
  const {
    fetchOrderItems,
    cartclose,
  } = useCart();
  const {
    fetchFavorites,
  } = useFavorites();
  const [enableExpress, setEnableExpress] = useState(false);

  const user = localStorage.getItem('user');
  const [productOfTheWeek, setProductOftheWeek] = useState('')
  const [shopByCats, setShopByCats] = useState('')
  const [selectionBanners, setSelectionBanners] = useState('')
  const [shopByCatsLoading, setShopByCatsLoading] = useState(false);
  const [productOfTheWeekLoading, setProductOfTheWeekLoading] = useState(false);
  const [selectionBannersLoading, setSelectionBannersLoading] = useState(false);

	// Track if below-the-fold content should be loaded
	const [loadNewArrivals, setLoadNewArrivals] = useState(false);
	const [loadPromotions, setLoadPromotions] = useState(false);
	const [loadPartners, setLoadPartners] = useState(false);

  window.onbeforeunload = () => {
    cartclose();
  };

	/**
	 * OPTIMIZED: Load only critical above-the-fold content first
	 * Priority 1: Hero carousel, Product of the Week, Shop by Categories
	 * Priority 2: Everything else loads on-demand when visible
	 */
	const initCriticalData = useCallback(async () => {
    setShopByCatsLoading(true);
    setProductOfTheWeekLoading(true);
		setSelectionBannersLoading(true);

    const [shopSetting] = await Promise.all([
      expressService.getShopSetting(),
	    props.offerSlider({store_id: 1}), // Hero carousel - critical
	    API.getBannerImages().then(res => res.json()).then(res => {
	    }),
      redAPI.getProductOfTheWeek().then(res => res.json())
        .then(res => {
          if(res.success){
            setProductOftheWeek(res.data[0].store_item_info);
          }
          setProductOfTheWeekLoading(false);
        }),
      redAPI.getShopByCats().then(res => res.json())
        .then(res => {
          if(res.success){
            setShopByCats(res.data);
          }
          setShopByCatsLoading(false);
        }),
      redAPI.getSelectionBanners().then(res => res.json())
      .then(res => {
        if(res.success){
          setSelectionBanners(res.data);
        }
        setSelectionBannersLoading(false);
      }),
    ]);

    if (shopSetting.status === 200) {
      setEnableExpress(shopSetting.data.enableExpress);
    }
    return await Promise.all([shopSetting]);
  }, []);

	/**
	 * Load New Arrivals when section becomes visible
	 */
	const handleLoadNewArrivals = useCallback(() => {
		if (!loadNewArrivals) {
			setLoadNewArrivals(true);
			props.getArrivalProducts({sub_cat_id: 187, store_id: 1});
		}
	}, [loadNewArrivals, props]);

	/**
	 * Load Promotions when section becomes visible
	 */
	const handleLoadPromotions = useCallback(() => {
		if (!loadPromotions) {
			setLoadPromotions(true);
			props.getPromotionProducts({sub_cat_id: 187, store_id: 1});
		}
	}, [loadPromotions, props]);

	/**
	 * Load Partner pages when section becomes visible
	 */
	const handleLoadPartners = useCallback(() => {
		if (!loadPartners) {
			setLoadPartners(true);
			// Partners loading is handled by PartnerHome component itself
		}
	}, [loadPartners]);

	useEffect(() => {
		localStorage.removeItem('expressMode');
		initCriticalData();
		// Scroll to top on page load
		window.scrollTo(0, 0);
	}, [initCriticalData]);


  useEffect(() => {
    if (user) {
      fetchOrderItems()
      fetchFavorites({ type: 0 });
    }
  }, [user])

  useEffect(() => {
	  const productCart = document.getElementsByClassName("product-cart")[0];
	  if (productCart) {
		  productCart.style.visibility = "hidden";
	  }

    if (localStorage.getItem("order_id") === undefined || localStorage.getItem("order_id") === null) {
      localStorage.setItem("order_id", 0)
    }

    if (window.location.pathname === "/register") {
      setCookie('homelockdownn', 'seen', 20);
      if (document.getElementById("joinBTn")) {
        document.getElementById("joinBTn").click();
      }
      else {
        alert("You are already logged in!");
      }
    }
    if (localStorage.getItem("user")) {
      if (localStorage.getItem("reordered")) {
        localStorage.setItem("reordered", false);
	      const productCart = document.getElementsByClassName("product-cart")[0];
	      if (productCart) {
		      productCart.click();
	      }
      }
    }
  }, []);

  useEffect(() => {
    if ((query.text || query.category) && targetRef.current) {
      window.scrollTo({
        top: targetRef.current.offsetTop - 110,
        behavior: "smooth",
      });
    }
  }, [query]);

  useEffect(() => {
    if(localStorage.getItem("admin") || localStorage.getItem("supplier")) return;
    props.getActivePromotionCampaign();
  }, [props]);

  useEffect(() => {
    props.checkShowCampaignBanner();
  }, [props.active_campaign, props]);

  function checkCampaignAvailable() {
    let displayAhead = new Date(
      minusHour(props.active_campaign?.sale_promotion_campaign_product?.display_ahead, 7)
    )?.getTime();

    let startDate = new Date(
      minusHour(props.active_campaign?.sale_promotion_campaign_product?.start_date, 7)
    )?.getTime();

    let now = new Date().getTime();

    return (
      props.active_campaign &&
      now > displayAhead &&
      startDate < now
    );
  }

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://delishop.asia/" />
        <title>Delishop - First Online Supermarket in Cambodia</title>
        <meta name="title" content="Delishop - First Online Supermarket in Cambodia" />
        <meta property="og:title" content="Delishop - First Online Supermarket in Cambodia" />
        <meta property="og:image" content="https://delishop.s3-ap-southeast-1.amazonaws.com/ds-ad.jpeg" />
        <meta property="og:description" content="Get all your favorite products from the best shops of Phnom Penh. More than 10,000 products to choose from" />
        <meta name="description" content="Get all your favorite products from the best shops of Phnom Penh. More than 10,000 products to choose from" />
        <meta name="keywords" content="bakery phnom penh, beef cambodia, beer cambodia, beer in cambodia, cheese cambodia, cheese phnom penh, coffee cambodia, coffee shop, cosmetics cambodia, deli market, deli shop, delimarket, delishop, delishop asia, delishop asia phnom penh, delishop cambodia, delishop phnom penh, delishop.asia, delivery phnom penh, fish phnom penh, fruit cambodia, fruit phnom penh, grocery, grocery delivery, grocery delivery phnom penh, grocery shopping, grocery store, meat cambodia, online groceries, online grocery, online grocery cambodia, online shop, online shopping, online supermarket, online supermarket phnom penh, organic, organic vegetables, phnom penh delivery, royal canin, shampoo cambodia, shampoo in cambodia, soda shop, supermarket cambodia, supermarket online shopping, tea in cambodia, tea phnom penh, the deli shop, vegetables cambodia, vegetables fresh, wine phnom penh" />

        {/* Preload critical images when available */}
        {props.sliders && props.sliders[0] && (
	        <link
		        rel="preload"
		        as="image"
            href={props.sliders[0].image_link}
            fetchpriority="high"
          />
        )}
        {productOfTheWeek && productOfTheWeek.default_image_url && (
	        <link
		        rel="preload"
		        as="image"
            href={productOfTheWeek.default_image_url}
            fetchpriority="high"
          />
        )}
      </Helmet>
      <div>
        {deviceType.desktop ? (
          <OfferSection>
            <div className="offer-desktop">
              <ExpressStyle style={{ marginTop: 10 }}>
                {enableExpress && (
                  <>
                    <div className="mobile">
                      <a href="/express" className="btnExpress">
                        <img
                          src={delishopExpressIcon}
                          alt="Delishop Express"
                          width="100%"
                          height="44"
                        />
                      </a>
                    </div>
                  </>
                )
                }
              </ExpressStyle>

              {props?.is_show  ? (
								<SalePromotionCampaignBanner
                  campaign={props.active_campaign}
                  resetCampaign={props.resetActivePromotionCampaign}
                />
							) : (
								<div className="row" style={{ margin: 0 }}>
                  {checkCampaignAvailable() && window.matchMedia("all and (max-width: 769px)").matches ? (
                    <div className="col-12 mt-3">
                      <CampaignDescriptions
                        style={{ paddingTop: "0.25rem" }}
                        onClick={() => {
                          window.location.href = `/campaign/${props.active_campaign?.campaign_id}`;
                        }}
                      >
                        <img
                          src={props.active_campaign?.icon}
                          alt={props.active_campaign?.name}
                          loading="lazy"
                          className="campaign-logo"
                        />
                        <div className="count-down-content">
                          <p className="campaign-promotion-end-in-label">
                            {t("promotion_campaign_ends_in_title")}
                          </p>
                          <SaleCampaignTimer
                            campaign={props.active_campaign}
                            resetCampaign={props.resetActivePromotionCampaign}
                          />
                        </div>
                      </CampaignDescriptions>
                    </div>
                  ) : null}
									<div className="col-md-7 col-lg-8 col-12">
										{props.slidersLoading ? (
											<HeroSkeleton type="carousel"/>
										) : (
										  <CustomCarousel deviceType={deviceType} props={props} />
										)}
									</div>
									<div className="col-md-5 col-lg-4 col-12">
										{productOfTheWeekLoading ? (
											<HeroSkeleton type="productOfWeek"/>
										) : productOfTheWeek !== "" ? (
											<ProductOfTheWeekCart product={productOfTheWeek}/>
										) : null}
									</div>
								</div>
							)}
            </div>
          </OfferSection>
        ) : (
	        <OfferSection>
		        <div className="offer-mobile">
			        {props.slidersLoading ? (
				        <HeroSkeleton/>
			        ) : (
				        <CustomCarousel deviceType={deviceType} data={props.sliders}/>
			        )}
		        </div>
	        </OfferSection>
        )}

        <MainContentArea>
	        {/* Shop by Categories - Critical content, load immediately */}
	        {shopByCatsLoading ? (
		        <CategoryListSkeleton itemCount={8}/>
	        ) : shopByCats !== '' ? (
		        <ShopByCategory deviceType={deviceType} cats={shopByCats} props={props}/>
	        ) : null}

	        {/* Selection Banners - Critical content, load immediately */}
          {selectionBannersLoading ?
	          <div
              className={`w-100 category-banner-height justify-content-center align-items-center`}
            >
              <Spinner animation="border" role="status" style={{color: "#9cc54b"}} />
            </div>
          :
            selectionBanners.length > 0?
              <TypeCategoriesBanner deviceType={deviceType} banners={selectionBanners}/>
            :null
          }

	        {/* New Arrivals - LAZY LOADED with skeleton */}
          <ContentSection id="productBlock" style={{ width: "100%" }}>
	          <LazySection
		          onVisible={handleLoadNewArrivals}
		          skeleton={<CarouselSkeleton itemCount={5} cartType={props.cartType}/>}
		          minHeight="400px"
		          rootMargin="300px"
	          >
		          <NewProducts
			          type={PAGE_TYPE}
			          deviceType={deviceType}
			          fetchLimit={16}
			          props={props}
		          />
	          </LazySection>

	          {/* Promotions - LAZY LOADED with skeleton */}
	          <LazySection
		          onVisible={handleLoadPromotions}
		          skeleton={<CarouselSkeleton itemCount={5} cartType={props.cartType}/>}
		          minHeight="400px"
		          rootMargin="300px"
	          >
              <PromoProducts
                type={PAGE_TYPE}
                deviceType={deviceType}
                fetchLimit={16}
                props={props}
              />
	          </LazySection>
          </ContentSection>

	        {/* Homepage Video - Already optimized with its own lazy loading */}
          <div style={{ width: "100%" }}>
	          <HomePageVideo deviceType={deviceType}/>
          </div>

	        {/* Partners and Reviews - LAZY LOADED with skeleton */}
          <ContentSection style={{ width: "100%" }}>
	          <LazySection
		          onVisible={handleLoadPartners}
		          skeleton={<PartnerSkeleton cardCount={7}/>}
		          minHeight="300px"
		          rootMargin="400px"
	          >
		          <PartnerHome deviceType={deviceType} props={props}/>
	          </LazySection>

	          <LazySection
		          skeleton={<ReviewSkeleton cardCount={3}/>}
		          minHeight="400px"
		          rootMargin="400px"
	          >
		          <ReviewCard/>
	          </LazySection>
          </ContentSection>
        </MainContentArea>

        <CartPopUp deviceType={deviceType} />
      </div>
    </>
  );
};

HomePage.getInitialProps = async (appContext) => {
  const { req } = appContext.ctx;
  const userAgent = req ? req.headers["user-agent"] : navigator.userAgent;
  return { userAgent };
};

const mapStateToProps = (state) => {
  return {
    success: state.authReducer.success,
    modalData: state.productReducer.modalData,
    products: state.productReducer.products,
    allproducts: state.productReducer.allproducts,
    promoproducts: state.productReducer.promoproducts,
    arrivalproducts: state.productReducer.arrivalproducts,
    trendingproducts: state.productReducer.trendingproducts,
    category: state.productReducer.category,
    sliders: state.globalReducer.sliders,
    loading: state.globalReducer.loading,
    promoloading: state.globalReducer.promoloading,
    arrivalloading: state.globalReducer.arrivalloading,
    trendloading: state.globalReducer.trendloading,
    slidersLoading: state.globalReducer.slidersLoading,
    brands: state.productReducer.brands,
    filterBrands: state.productReducer.filterBrands,
    FilteredNameProducts: state.productReducer.FilteredNameProducts,
    filteredProducts: state.productReducer.filteredProducts,
    suggested_subcats: state.productReducer.suggested_subcats,
    oos: state.globalReducer.oos,
    togglesuggestion: state.productReducer.togglesuggestion,
    page: state.productReducer.page,
    cat_refs: state.productReducer.cat_refs,
    slots_for_date: state.userReducer.slots_for_date,
    all_slots: state.userReducer.all_slots,
    all_timings: state.userReducer.all_timings,
    calendar_response: state.userReducer.calendar_response,
    delivery_slots: state.userReducer.delivery_slots,
    active_campaign: state.promotionCampaignReducer.active_campaign,
    is_show: state.promotionCampaignReducer.is_show,
    all_pages: state.globalReducer.all_pages,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    productCategory: (data) => productCategory(data, dispatch),
    ProductModalData: (data) => ProductModalData(data, dispatch),
    searchSuggestions: (data) => searchSuggestions(data, dispatch),
    searchStoreProduct: (data) => searchStoreProduct(data, dispatch),
    getProductsMappedwithSubCat: (data) => getProductsMappedwithSubCat(data, dispatch),
    getProductsMappedwithCat: (data) => getProductsMappedwithCat(data, dispatch),
    offerSlider: (data) => offerSlider(data, dispatch),
    getProductOutOfStock: (body) => getProductOutOfStock(body, dispatch),
    getProductOutOfStockCat: (body) => getProductOutOfStockCat(body, dispatch),
    getPromotionProducts: (body) => getPromotionProducts(body, dispatch),
    getArrivalProducts: (body) => getArrivalProducts(body, dispatch),
    getTrendingProducts: (body) => getTrendingProducts(body, dispatch),
    getProductBrands: () => getProductBrands(dispatch),
    getSortProductsName: (type, products) =>
      getSortProductsName(type, products, dispatch),
    getSortProductsPrice: (type, products) =>
      getSortProductsPrice(type, products, dispatch),
    getProductFilterBrands: (body, products, allproducts, sub_cat_id, cat_id, oos, text) =>
      getProductFilterBrands(body, products, allproducts, sub_cat_id, cat_id, oos, text, dispatch),
    sortByNameProduct: (type, products) =>
      sortByNameProduct(type, products, dispatch),
    oosModified: (data) => oosModified(data, dispatch),
    Reset_Suggestions: () => Reset_Suggestions(dispatch),
    changePage: (body) => changePage(body, dispatch),
    resetPage: () => resetPage(dispatch),
    slotsForDate: (data) => slotsForDate(data, dispatch),
    alldeliverySlots: (data) => alldeliverySlots(data, dispatch),
	  getActivePromotionCampaign: () => getActivePromotionCampaign(dispatch),
	  resetActivePromotionCampaign: () => resetActivePromotionCampaign(dispatch),
    checkShowCampaignBanner: () => checkShowCampaignBanner(dispatch),
	  getPartnerPages: (body) => getPartnerPages(body, dispatch),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
